import { DEFAULT_SHIPMENT_METHOD } from './costingOptions';
import type { CoreProductLine, GradingGroupLine, MultiSubmitRow } from './types';

let gradingSeq = 0;
/** Factory for a blank grading line (ids are local-only, stable within a session). */
export function makeGradingLine(): GradingGroupLine {
  gradingSeq += 1;
  return { id: `grading-${gradingSeq}`, gradingGroup: '', size: [], length: '', quantity: '', uom: '' };
}

let coreSeq = 0;
/** Factory for a blank Core Product line (ids are local-only, stable within a session). */
export function makeCoreLine(): CoreProductLine {
  coreSeq += 1;
  return { id: `core-${coreSeq}`, colourway: [], size: [], length: [], quantity: '', pricePerUnit: '', totalPrice: '', selected: false };
}

/** Build a blank grid row for a product (id = devOrderId). */
export function makeRow(devOrderId: string, productNumber: string): MultiSubmitRow {
  return {
    id: devOrderId,
    productNumber,
    cwChecked: false,
    productColourways: [],
    selected: false,
    expanded: false,
    cpChecked: false,
    purchaseOrders: [],
    tpDesignDetails: false,
    tpBom: false,
    tpSpecification: false,
    tpSpecificationValue: [],
    tpTesting: false,
    tpCare: false,
    tpSample: false,
    tpSampleValue: [],
    tpCombineYes: true,
    sdDesignDetails: false,
    sdDesignDetailsValue: [],
    sdColour: false,
    sdColourValue: [],
    sdBom: false,
    sdBomValue: [],
    sdSpecification: false,
    sdSpecificationValue: [],
    sdPomGuide: false,
    sdPomGuideValue: [],
    sdPurchaseOrder: false,
    sdPurchaseOrderValue: [],
    sdTestingReport: false,
    sdCareLayout: false,
    rsChecked: false,
    sampleTypeGroup: '',
    typeOfSampleType: '',
    sampleType: '',
    sampleNumber: '',
    rsSupplier: '',
    dueDate: '',
    factory: '',
    colourway: '',
    gradingLines: [makeGradingLine()],
    parentId: null,
    revisionRootId: null,
    versionNumber: 1,
    ciReference: '',
    ciSupplier: '',
    ciFactory: '',
    ciCostingTemplate: '',
    ciCurrency: '',
    ciMoqNeeded: '',
    ciTargetCost: '',
    ciIncoterms: '',
    ciShipmentMethod: DEFAULT_SHIPMENT_METHOD,
    ciSampleRef: '',
    coreLines: [makeCoreLine()],
    invite: false,
    emailTo: '',
    emailCc: '',
    emailBcc: '',
    emailMessage: '',
  };
}
